













































import { defineComponent, computed, ref, watch } from "@vue/composition-api";
import { enrollState } from "@/store";
import useDevice from "@/utilities/useDevice";
export default defineComponent({
    props: {
        imgSrc: { type: String },
        value: { type: Boolean, default: false },
        deviceType: { type: Number, default: 0 }
    },
    setup(props, context) {
        const actionText = ref("Preparing enrollment..");
        const timeLeft = ref(60);
        const enrollInProgress = ref(false);
        const progress = computed(() => !enrollState.EnrollInProgress);
        const dialog = computed(() => {
            return props.value;
        });
        const close = () => {
            actionText.value = "Preparing enrollment..";
            timeLeft.value = 60;
            context.emit("input", false);
        };
        watch(
            () => props.value,
            () => {
                if (props.value) {
                    enrollState.StartEnroll(props.deviceType);
                } else {
                    enrollInProgress.value = false;
                    actionText.value = "Preparing enrollment..";
                    timeLeft.value = 60;
                }
            }
        );

        let countdownInterval = null;

        function startCountdown() {
            timeLeft.value = 60; // set initial time left to 60 seconds
            actionText.value = "Ready to enroll!";
            enrollInProgress.value = true;

            countdownInterval = setInterval(() => {
                timeLeft.value--;
                if (timeLeft.value <= 0) {
                    clearInterval(countdownInterval);
                    countdownInterval = null;
                    close();
                } else {
                    actionText.value = "Ready to enroll!";
                }
            }, 1000);
        }

        enrollState.$watch(
            module => module.EnrollInProgress,
            (newValue, oldValue) => {
                if (newValue) {
                    if (!countdownInterval) {
                        startCountdown();
                    }
                } else {
                    if (actionText.value.startsWith("Ready to enroll!") && !newValue) {
                        clearInterval(countdownInterval);
                        countdownInterval = null;
                        close();
                    }
                }
            }
        );


        return {
            dialog,
            close,
            actionText,
            timeLeft,
            progress,
            enrollInProgress,
            ...useDevice()
        };
    }
});
